module.exports = __webpack_public_path__ + "img/交通-01.60e03af5.png";